import logo from '../../../assets/images/logo/hydrafacial.svg'
import { useState, useEffect } from 'react'
import './downloadApp.scss'
import { getDeviceType } from '../../../utils/helper-functions'
import { GetLoyaltyAppData } from '../../../services/contentStack'

const DownloadApp = () => {
    const [deviceType, setDeviceType] = useState('')
    useEffect(() => {
        const handleResize = () => {
            let device = getDeviceType()
            setDeviceType(device)
            getRewardData()
        }
        window.addEventListener('resize', handleResize)
        handleResize()
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [deviceType])

    const getRewardData = async () => {
        try {
            const response: any = await GetLoyaltyAppData()
            if (response) {
                let applicationUrl = ''
                if (deviceType === 'Android') {
                    applicationUrl = response.find(
                        (item: any) =>
                            item.node.title === 'loyalty_play_store_url'
                    )?.node.value
                } else if (deviceType === 'iPhone/iOS') {
                    applicationUrl = response.find(
                        (item: any) =>
                            item.node.title === 'loyalty_app_store_url'
                    )?.node.value
                }
                if (applicationUrl) {
                    window.location.href = applicationUrl
                }
            }
        } catch (e) {
            console.log(e)
            throw e
        }
    }

    return (
        <div className="download-app-container">
            <div className="logo">
                <img src={logo} alt="hydrafacial_logo"></img>
            </div>
        </div>
    )
}

export default DownloadApp
